import { CreateContainer } from "../../../Containers/ContainerCreate";
import EndlessScrollContainer from "../../../Containers/EndlessScrollContainer";
import { getChimneyProfileTracks } from "../../../api/getChimneyProfile";

class EndlessScrollChimneyProfileTracksContainer extends EndlessScrollContainer {
    constructor(props) {
        super(props);
        this.state = {
            page: 1,
            hasMore: false,
            type: "track",
            filter: props.chimDir || "",
            items: [],
            isLoading: false,
            initialLoading: true
        };
    }

    fetch = () => {
        if (this.state.isLoading) {
            return;
        }

        this.setState({ isLoading: true });
        const chimDir = this.props.chimDir || this.state.filter;
        this.props.request(chimDir, this.state.page).then(({ data: { tracks, pager } }) => {
            // Check if there are more pages based on pager or track count
            // Assuming tracks per page is consistent (typically 19 based on comment in ChimneyProfileTracksContainer)
            const perPage = pager?.perPage || 19;
            const hasMore = tracks && tracks.length === perPage;
            const items = [...this.state.items, ...tracks];
            this.setState({
                items,
                page: this.state.page + 1,
                hasMore,
                isLoading: false,
                initialLoading: false
            }, () => {
                // Notify parent of items count change
                if (this.props.onItemsChange) {
                    this.props.onItemsChange(items.length);
                }
            });
        }).catch(() => {
            this.setState({ isLoading: false, initialLoading: false });
        });
    };

    componentDidUpdate(prevProps, prevState) {
        // Notify parent when items change (e.g., on initial load)
        if (prevState.items.length !== this.state.items.length && this.props.onItemsChange) {
            this.props.onItemsChange(this.state.items.length);
        }
    }
}

EndlessScrollChimneyProfileTracksContainer.defaultProps = {};
export default CreateContainer(getChimneyProfileTracks, EndlessScrollChimneyProfileTracksContainer);

